import React, {useEffect, useState} from 'react';
import Layouts from '../../components/Layouts';
import HeaderContentComponent from '../../components/headerContentComponent';
import {PlusOutlined} from '@ant-design/icons';
import {
    Button,
    Dropdown,
    Flex, Form, Input,
    MenuProps,
    message,
    Modal,
    Space,
    Tabs, TabsProps,
} from 'antd';
import {ArchiveIcon, DownloadIcon} from '../../assets/image/svg';
import {IColumnType, IPagination} from '../../components/tableComponent/Table';
import {columns} from './columns';
import DrawerComponent from '../../components/DrawerComponent';
import FormNewBet from './formNewBet';
import {useStoreDispatch} from '../../store';
import {
    clearCommentReducers,
    deleteCommentReducers,
    getAllBids,
    getAllBidsExcel, setBreadcrumb,
    setCommentReducers,
    setIsArchive, updateAllDepartment,
} from '../../store/bids';
import socket from '../../socket';
import FormViewBet from './formViewBet';
import {clearFiltersFetch, filtersBits, getFiltersBits} from '../../store/filters';
import {jsPDF} from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';
import Tooltips from './tooltips';
import {DataAllBidsItem, StorageData} from '../../types';
import {SessionStorageManager} from '../../components/tableComponent/sessionStorageManager';
import {useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import * as XLSX from 'xlsx';
import NumericInput from '../../components/NumericInput/NumericInput';
import TableView from './TableView';
import {Utils} from '../../utils';
import {setLang} from '../../store/stores';
import {suffixSelector} from './symbol';

declare module 'jspdf' {
    interface jsPDF {
        autoTable: any;
    }
}

const Index = () => {
    const dispatch = useStoreDispatch();
    const location = useLocation();
    const [form] = Form.useForm();
    const {t, i18n} = useTranslation();
    const [langs, setLangs] = useState<string>();
    const [dataAllBids, setDataAllBids] = useState<any>([]);
    const [openDrawerContainer, setOpenDrawerContainer] = useState<boolean>(false);
    const [openDrawerViewContainer, setOpenDrawerViewContainer] = useState<boolean>(false);
    const [current, setCurrent] = useState<number>(1);
    const [page, setPage] = useState<number>(10);
    const [total, setTotal] = useState<number>(0);
    const [loading, setLoading] = useState(true);
    const [dataRows, setDataRows] = useState<any[]>([]);
    const [isTypeForm, setIsTypeForm] = useState<boolean>(true);
    const [columnFilters, setColumnFilters] = useState({});
    const [checkedAll, setCheckedAll] = useState<any[]>([]);
    const [confirmation, setConfirmation] = useState<boolean>(false);
    const [allSelected, setAllSelected] = useState<any>({});
    const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());
    const [isOpenRefBet, setIsOpenRefBet] = useState(false);
    const [refBetPrice, setRefBetPrice] = useState<any>(null);
    const [refBetCNP, setRefBetCNP] = useState<any>(0);
    const [refBetColKtk, setRefBetColKtk] = useState<any>(0);
    const [dataCity1, setCity1] = useState<[]>([]);
    const [dataCity2, setCity2] = useState<[]>([]);
    const storageManager = new SessionStorageManager(location.pathname + langs);
    const storageLocal: any = storageManager.getItem();
    const locale: any = localStorage.getItem('i18nextLng');

    const fetchData = (current: number, page: number, order: string) => {
        if (storageLocal?.fiters) {
            filtersColumn(storageLocal?.fiters, current, page, 'DESC');
        } else {
            if (langs) {
                dispatch(getAllBids({current: current, page, order, is_archive: false, locale: langs}));
            }
        }
    };

    const handleOrder = (order: string) => {
        setLoading(true);
        if (storageLocal) {
            dispatch(getAllBids({current: current, page, order, is_archive: false, locale: langs}));
        } else {
            dispatch(getAllBids({current: current, page, order, is_archive: false, locale: langs}));
        }
    };

    const filtersColumn = (data: any, current: number, page: number, order: string) => {
        setLoading(true);
        if (storageLocal && storageLocal.pagination !== undefined) {
            storageLocal.pagination.current = current;
            storageLocal.pagination.page = page;
            storageManager.setItem(storageLocal);
        }

        setCurrent(current);
        if (langs) {
            if (data && Object.keys(data).length > 0) {
                dispatch(
                    getFiltersBits({
                        data: data,
                        current: current,
                        page: page,
                        is_archive: false,
                        order: order ? order : 'DESC',
                        locale: langs,
                    }),
                );
            } else {
                dispatch(
                    getAllBids({
                        current: current,
                        page: page,
                        is_archive: false,
                        order: order ? order : 'DESC',
                        locale: langs,
                    }),
                );
            }
        }
    };

    useEffect(() => {
        if (storageLocal) {
            setCurrent(storageLocal.pagination.current);
            setColumnFilters(storageLocal.arrFilters);
            setCurrent(storageLocal.pagination.current);
            setPage(storageLocal.pagination.page);
            filtersColumn(storageLocal?.fiters, storageLocal.pagination.current, storageLocal.pagination.page, 'DESC');
        } else {
            fetchData(current, page, 'DESC');
        }

        if (locale) {
            setLangs(locale);
        } else {
            setLangs(locale);
        }
        i18n.changeLanguage(langs).then((r) => r);
        socket.on('return-get-all-bids', resAllBids);
        socket.on('return-set-bet', resSetBet);
        socket.on('return-update-bet', resUpdateBet);
        socket.on('return-set-archive', resSetArchive);
        socket.on('return-get-filters-bits', resFiltersBits);
        socket.on('return-comment-delete', resCommentDelete);
        socket.on('return-comment-all', resCommentAll);
        socket.on('return-get-all-bids-excel', resAllBidsExcel);
        socket.on('return-update-bet-all', resUpdateBetAll);

        return () => {
            socket.off('return-get-all-bids', resAllBids);
            socket.off('return-set-bet', resSetBet);
            socket.off('return-update-bet', resUpdateBet);
            socket.off('return-set-archive', resSetArchive);
            socket.off('return-get-filters-bits', resFiltersBits);
            socket.off('return-comment-delete', resCommentDelete);
            socket.off('return-comment-all', resCommentAll);
            socket.off('return-get-all-bids-excel', resAllBidsExcel);
            socket.off('return-update-bet-all', resUpdateBetAll);
        };
    }, [locale, langs]);

    const resUpdateBetAll = (response: any) => {
        try {
            if (response && response.rows) {
                setIsOpenRefBet(false);
                setSelectedRows(new Set());
                setRefBetPrice('');
                setDataAllBids((prevData: any) => {
                    return prevData.map((row: any) => {
                        const matchedElement = response.rows.find(
                            (el: any) => row.id === el.id,
                        );
                        if (matchedElement) {
                            return {
                                ...row,
                                bet: matchedElement.bet,
                                cnp: matchedElement.cnp,
                                col_ktk: matchedElement.col_ktk,
                                symbol: matchedElement.symbol
                            };
                        }
                        return row;
                    });
                });
            } else {
                console.error('Некорректные данные:', response);
            }
        } catch (error) {
            console.error('Ошибка при обновлении ставок:', error);
        } finally {
            setLoading(false);
        }
    };

    const resCommentAll = (response: any) => {
        dispatch(setCommentReducers(response));
    };

    const resCommentDelete = (response: any) => {
        if (response) {
            message.info('Комментарий удален');
            dispatch(deleteCommentReducers(response.data));
            if (response) {
                setDataAllBids((prevData: any) => {
                    const updatedData = [...prevData];
                    [response.rows].forEach((newItem: any) => {
                        let indexD = 0;
                        if (response.rows.length > 0) {
                            indexD = updatedData.findIndex((item: any) => item.id == newItem[0].bet_id);
                            if (indexD !== -1) {
                                updatedData[indexD].comment = response.rows[0].text;
                            }
                        } else {
                            const index = updatedData.findIndex(item => item.id == response.data.bet_id);
                            updatedData[index].comment = null;
                        }
                    });
                    return updatedData;
                });

            }
        } else {
            message.error('Ошибка удаления');
        }
    };

    const resFiltersBits = (response: any) => {
        setLoading(false);
        if (response.length > 0) {
            if ([response[0].data.rows].length > 0) {
                const storageData: StorageData = {
                    pagination: {
                        current: response[0].current,
                        page: response[0].page,
                        total: response[0].data.count,
                    },
                };
                storageManager.updateItem(storageData);
                setTotal(response[0].data.count);
                setDataAllBids(response[0].data.rows);
            } else {
                message.error('Ошибка фильтрации!');
            }
        } else {
            message.error('Ошибка фильтрации!');
        }
    };

    const resSetArchive = (response: any) => {
        if (response) {
            setDataAllBids([]);
            setDataAllBids(response.rows);
            setTotal(response.count);
            setLoading(false);
            setAllSelected(false);
        }
    };

    const resUpdateBet = (response: any) => {
        if (response) {
            setDataAllBids((prevData: any) => {
                const updatedData = [...prevData];
                response[0].forEach((newItem: any) => {
                    const index = updatedData.findIndex((item) => item.id === newItem.id);
                    if (index !== -1) {
                        // Обновляем существующий объект
                        updatedData[index] = newItem;
                    } else {
                        // Добавляем новый объект
                        updatedData.unshift(newItem);
                    }
                });
                return updatedData;
            });
        }
    };

    const resSetBet = (response: any) => {
        if (response) {
            setDataAllBids([]);
            setCurrent(1);
            setTotal(response.count);
            setDataAllBids(response.rows);
            setColumnFilters([{}]);
        }
    };

    const resAllBids = (response: any) => {
        setDataAllBids([]);
        if (response) {
            const data = response.order === 'DESC' ? response.rows : response.rows.reverse();
            setDataAllBids(data);
            setTotal(response.count);
        }
        setLoading(false);
    };

    const downloadExcel = (response: any) => {
        if (response.rows.length > 0) {
            const rows = response.rows.map(
                ({
                     created_at, department, country1, city1, country2, city2, col_ktk, type_ktk, quality, bet,
                     bet_int, symbol, subsidy,bet_1_crane, bet_1_day, free_days, cnp, comment,
                 }: DataAllBidsItem) =>
                    ({
                        created_at: moment(created_at).format('DD.MM.YYYY'),
                        department,
                        country1,
                        city1,
                        country2,
                        city2,
                        col_ktk,
                        type_ktk,
                        quality,
                        bet: bet_int !== null ? bet_int : bet,
                        symbol,
                        subsidy,
                        bet_1_crane,
                        bet_1_day,
                        free_days,
                        cnp,
                        comment,
                    }),
            );

            const workbook = XLSX.utils.book_new();
            const worksheet = XLSX.utils.json_to_sheet(rows);

            const colLengths = Object.keys(rows[0]).map((k) => k.toString().length);
            for (const d of rows) {
                Object.values(d).forEach((element, index) => {
                    if (element !== null && element !== undefined) {
                        const length = element.toString().length;
                        if (colLengths[index] < length) {
                            colLengths[index] = length;
                        }
                    }
                });
            }
            worksheet['!cols'] = colLengths.map((l, index) => {
                if (
                    index === 0 ||
                    index === 1 ||
                    index === 5 ||
                    index === 6 ||
                    index === 7 ||
                    index === 8 ||
                    index === 9
                ) {
                    return {
                        wch: 10,
                    };
                } else {
                    return {
                        wch: 20,
                    };
                }
            });
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Ставки');

            if (langs === 'ru') {
                XLSX.utils.sheet_add_aoa(worksheet, [
                    ['Дата обновления', 'Услуга', 'Страна выдачи', 'Город выдачи', 'Страна сдачи', 'Город сдачи',
                        'Кол-во КТК', 'Тип КТК', 'Качество', 'Ставка','Валюта','Субсидия', 'Ставка 1 кран', 'Ставка 1 день', 'Свободные дни', 'СНП', 'Комментарии'],
                ]);
            }else {
                XLSX.utils.sheet_add_aoa(worksheet, [
                    ['Date', 'Service', 'Country of issue', 'City of issue', 'Return country', 'Return city',
                        'Number of containers', 'Container type', 'Quality', 'Bet', 'Currency', 'Subsidy','Rate per lift', 'Rate per day', 'Free days', 'SNP', 'Comments'],
                ]);
            }

            XLSX.writeFile(workbook, 'Актуальные ставки MyContainers на ' + moment().format('DD.MM.YYYY') + '.xlsx', {compression: true});
        } else {
            message.info('Не выбранны строки для скачивания');
        }
    };

    const resAllBidsExcel = (response: any) => {
        setLoading(false);
        if (response) {
            if (response.download_type === 'excel' || response.download_type === 'excelAll') {
                downloadExcel(response.data);
            } else {
                if (response.data.rows.length > 0) {
                    const rows = response.data.rows.map(({
                                                             created_at,
                                                             department,
                                                             country1,
                                                             city1,
                                                             country2,
                                                             city2,
                                                             col_ktk,
                                                             type_ktk,
                                                             quality,
                                                             bet,
                                                             bet_int,
                                                             symbol,
                                                             subsidy,
                                                             bet_1_crane,
                                                             bet_1_day,
                                                             free_days,
                                                             cnp,
                                                             comment,
                                                         }: DataAllBidsItem) => ({
                        created_at: moment(created_at).format('DD.MM.YYYY'),
                        department,
                        country1,
                        city1,
                        country2,
                        city2,
                        col_ktk,
                        type_ktk,
                        quality,
                        bet,
                        bet_int,
                        symbol,
                        subsidy,
                        bet_1_crane,
                        bet_1_day,
                        free_days,
                        cnp,
                        comment,
                    }));

                    const doc = new jsPDF('landscape');
                    const myFont = '/PT_Sans-Web-Regular.ttf';
                    doc.addFont(myFont, 'PTSans', 'normal');
                    doc.setFont('PTSans');
                    doc.setFontSize(22);

                    // Генерация таблицы
                    const tableData = rows.map((row: any) => [
                        row.created_at,
                        row.department,
                        row.country1,
                        row.city1,
                        row.country2,
                        row.city2,
                        row.col_ktk,
                        row.type_ktk,
                        row.quality,
                        row.bet = row.bet_int !== null ? row.bet_int : row.bet,
                        row.symbol,
                        row.subsidy,
                        row.bet_1_crane,
                        row.bet_1_day,
                        row.free_days,
                        row.cnp,
                        row.comment
                    ]);

                    // Настройки таблицы
                    const tableConfig = {
                        head: [langs === 'ru' ? ['Дата обновления', 'Услуга', 'Страна выдачи', 'Город выдачи', 'Страна сдачи', 'Город сдачи',
                            'Кол-во КТК', 'Тип КТК', 'Качество', 'Ставка','Валюта','Субсидия', 'Ставка 1 кран', 'Ставка 1 день', 'Свободные дни', 'СНП', 'Комментарии']
                        : ['Date', 'Service', 'Country of issue', 'City of issue', 'Return country', 'Return city',
                                'Number of containers', 'Container type', 'Quality', 'Bet', 'Currency', 'Subsidy','Rate per lift', 'Rate per day', 'Free days', 'SNP', 'Comments']],
                        body: tableData,
                        theme: 'grid',
                        headStyles: {
                            lineWidth: 0.1,
                            fillColor: [255, 255, 255],
                            textColor: [21, 21, 21],
                            font: 'PTSans',
                            fontStyle: 'bold',
                            halign: 'center',
                        },
                        bodyStyles: {
                            fillColor: [255, 255, 255],
                            textColor: [21, 21, 21],
                            font: 'PTSans',
                        },
                        textColor: 20,
                        margin: {top: 20, left: 10, right: 10},
                        styles: {fontSize: 10, fontStyle: 'italic'},
                        tableWidth: 'auto',
                        columnStyles: {
                            0: {halign: 'center'},
                            1: {halign: 'center'},
                            2: {halign: 'center'},
                            3: {halign: 'center'},
                            4: {halign: 'center'},
                            5: {halign: 'center'},
                            6: {halign: 'center'},
                            7: {halign: 'center'},
                            8: {halign: 'center'},
                            9: {halign: 'center'},
                            10: {halign: 'center'},
                            11: {halign: 'center'},
                            12: {halign: 'center'},
                            13: {halign: 'center'},
                            14: {halign: 'center'},
                            15: {halign: 'center'},
                            16: {halign: 'center'},
                        },
                    };

                    doc.text('Актуальные ставки MyContainers на ' + moment().format('DD.MM.YYYY'), 10, 10);
                    // Добавляем таблицу в PDF
                    doc.autoTable(tableConfig);

                    const y = 70; // Отступ от верхнего края

                    const applyOpacityToImage = (imageSrc: string, opacity: number, callback: (dataUrl: string) => void) => {
                        const img = new Image();
                        img.src = imageSrc;

                        img.onload = function () {
                            const canvas = document.createElement('canvas');
                            const ctx: any = canvas.getContext('2d');

                            // Set canvas size to match the image
                            canvas.width = img.width;
                            canvas.height = img.height;

                            // Set opacity
                            ctx.globalAlpha = opacity;

                            // Draw image to canvas with the opacity
                            ctx.drawImage(img, 0, 0);

                            // Get the base64 data of the image with opacity applied
                            const dataUrl = canvas.toDataURL('image/png');

                            // Use this base64 data URL for the image in jsPDF
                            callback(dataUrl);
                        };
                    };

                    applyOpacityToImage('/mk.png', 0.5, (dataUrl) => {
                        const totalPages = doc.internal.pages.length;
                        for (let i = 1; i <= totalPages; i++) {
                            doc.setPage(i);
                            doc.addImage(dataUrl, 'PNG', 10, y, 250, 90);
                        }

                        doc.save('Ставки Мой Контейнер ' + moment().format('DD.MM.YYYY') + '.pdf');
                    });
                } else {
                    message.info(t('LinesSelected'));
                }
            }
        }
    };

    const handleDownload = (type: string) => {
        // Функция для сброса состояния
        const resetSelection = () => {
            setSelectedRows(new Set());
            setAllSelected(false);
            setCheckedAll([]);
        };

        if (type === "excelAll") {
            if (storageLocal && Object.keys(storageLocal?.fiters?.[0]).length > 0) {
                setLoading(true);
                dispatch(getAllBidsExcel({
                    checked: checkedAll,
                    is_archive: false,
                    download_type: type,
                    locale: langs,
                    filters: storageLocal?.fiters
                }));
                resetSelection();
            } else {
                message.info(t('ChooseService'));
            }
        } else if (type === "excel" || type === "pdf") {
            if (checkedAll.length > 0) {
                setLoading(true);
                dispatch(getAllBidsExcel({
                    checked: checkedAll,
                    is_archive: false,
                    download_type: type,
                    locale: langs,
                    filters: storageLocal?.fiters
                }));
                resetSelection();
            } else {
                message.info(t('LinesSelected'));
            }
        }
    };

    const showModalConfirmArchive = () => {
        if (Array.from(selectedRows).length > 0) {
            setConfirmation(true);
        } else {
            message.warning('Нет выделенных ячеек');
        }
    };

    const arButton = () => {
        const items: MenuProps['items'] = [
            {key: '1', label: (<div onClick={() => handleDownload('excel')}>{t('DownloadExcel')}</div>)},
            {key: '2', label: (<div onClick={() => handleDownload('pdf')}>{t('DownloadPDF')}</div>)},
            {key: '3', label: (<div onClick={() => handleDownload('excelAll')}>{t('DownloadAllExcel')}</div>)},
        ];
        return (
            <>
                <Tooltips title={t('NewBid')}>
                    <Button icon={<PlusOutlined/>} onClick={handleShowDrawerContainer}/>
                </Tooltips>
                <Tooltips title={t('Archive')}>
                    <Button icon={<ArchiveIcon/>} onClick={showModalConfirmArchive}/>
                </Tooltips>
                <Dropdown menu={{items}} placement="bottomRight">
                    <Button icon={<DownloadIcon/>}/>
                </Dropdown>
            </>
        );
    };

    const handleShowDrawerContainer = () => {
        setOpenDrawerContainer(true);
        setIsTypeForm(true);
        setDataRows([]);
    };

    const onMouseEditRight = (payload: any) => {
        setDataRows([payload]);
        setOpenDrawerContainer(true);
        setIsTypeForm(false);
    };

    const onRowDouble = (payload: any) => {
        setOpenDrawerViewContainer(true);
        setDataRows([payload]);
    };

    const closeFormViewBet = () => {
        setOpenDrawerViewContainer(false);
        dispatch(clearCommentReducers());
    };

    const closeFormNewBet = () => {
        setOpenDrawerContainer(false);
        dispatch(clearCommentReducers());
    };

    const handleArchive = (selectedRows: any, item: any) => {
        const dataArchive: number[] =
            checkedAll.length > 0
                ? checkedAll
                    .map((id: number) => {
                        const foundItem = dataAllBids.find(
                            (el: { id: number; is_archive: boolean }) =>
                                el.id === id && !el.is_archive,
                        );
                        return foundItem ? foundItem.id : null;
                    })
                    .filter((id): id is number => id !== null)
                : [item.id];

        if (dataArchive.length > 0) {
            setCheckedAll([]);
            dispatch(
                setIsArchive({
                    current: current,
                    page: page,
                    data: dataArchive,
                    is_archive: false,
                    locale: langs
                }),
            );
        }
    };

    const filtersFetch = (text: string | number, column: IColumnType<any>) => {
        dispatch(filtersBits({text: text, column: column, is_archive: false, locale: locale}));
    };

    const handleRowSelect = async (value: any) => {
        setCheckedAll(Array.from(value));
    };

    const onCloseModalConfirm = () => {
        setConfirmation(false);
        setCheckedAll([]);
    };

    const onOkModalConfirm = () => {
        handleArchive([], []);
    };

    const onChangePagination = async (page: IPagination<any>) => {
        setLoading(true);
        setCurrent(page.current);
        setPage(page.pageSize);
        setAllSelected({checked: false});
        try {
            const storageData: StorageData = {
                bull: storageLocal?.bull,
                pagination: {page: page.pageSize, current: page.current, total: page.total},
            };
            storageManager.setItem(storageData);
            if (page.current != null && page.pageSize != null) {
                fetchData(page.current, page.pageSize, 'DESC');
            }
        } catch (error) {
            console.error('Error changing pagination:', error);
        }
    };

    const handleRefBet = (row: any, el: string) => {
        if (checkedAll.length > 0) {
            setIsOpenRefBet(true);
        } else {
            message.info('Нет данных для изменения ставки!');
        }
    };

    const handleOkRefBet = (data: any) => {
        setLoading(true);
        dispatch(updateAllDepartment({
            ids: checkedAll,
            bet: data.bet,
            cnp: data.cnp,
            col_ktk: data.col_ktk,
            locale: langs,
            symbol: data.symbol,
            page: page,
            current: current
        }));
        setRefBetPrice('');
        setRefBetCNP(0);
        setRefBetColKtk(0);
    };

    const handleCancelRefBet = () => {
        setIsOpenRefBet(false);
        setRefBetPrice('');
        setRefBetCNP(0);
        setRefBetColKtk(0);
    };

    const handleInputChangeRefBet = (e: React.ChangeEvent<HTMLInputElement>) => {
        setRefBetPrice(e.target.value);
    };

    const handleInputChangeCNP = (e: any) => {
        setRefBetCNP(e);
    };

    const handleInputChangeColKtk = (e: any) => {
        setRefBetColKtk(e);
    };

    const handleTab = (key: string) => {
        try {
            setLoading(true);
            setCity1([]);
            setCity2([]);
            dispatch(clearFiltersFetch());
            const newLang = key === '1' ? 'ru' : 'en'; // Определяем новый язык
            const storageKey = 'i18nextLng';

            setLangs(newLang);
            Utils.setStorage(storageKey, newLang);
            dispatch(setLang(newLang));

            const storageData: StorageData = {
                fiters: [{}],
                bull: storageLocal?.bull,
                pagination: {page: 10, current: 1, total: total},
            };
            storageManager.updateItem(storageData);

            i18n.changeLanguage(newLang)
                .then(() => {
                    // После успешного изменения языка загружаем данные
                    dispatch(getAllBids({current: 1, page: 10, is_archive: false, order: 'DESC', locale: newLang}));
                    dispatch(setBreadcrumb([{title: t('Bids')}, {title: t('Current')}]));
                })
                .catch((error) => {
                    console.error('Error changing language:', error);
                });
        } catch (error) {
            console.log(error);
        }
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'RU',
            children: <TableView
                allSelected={allSelected}
                setAllSelected={setAllSelected}
                selectAll={handleRowSelect}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                handleRefBet={handleRefBet}
                setColumnFilters={setColumnFilters}
                columnFilters={columnFilters}
                onMouseTextRight={[
                    t('Edit'),
                    t('Archive'),
                    t('ChangeBids'),
                    'Массовое изменение стран',
                    'Массовое изменение городов',
                ]}
                onMouseEditRight={onMouseEditRight}
                onRow={onRowDouble}
                order={handleOrder}
                pagination={{
                    pageSize: page,
                    total: Number(total),
                    current: current,
                    showSizeChanger: true,
                }}
                onChangePagination={onChangePagination}
                filters={filtersColumn}
                filtersFetch={filtersFetch}
                handleDeleteCopyAll={handleArchive}
                columns={columns(t)}
                loading={loading}
                height={'calc(-231px + 100vh)'}
                dataSource={dataAllBids}
                langs={langs}/>,
        },
        {
            key: '2',
            label: 'EN',
            children: <TableView
                allSelected={allSelected}
                setAllSelected={setAllSelected}
                selectAll={handleRowSelect}
                setSelectedRows={setSelectedRows}
                selectedRows={selectedRows}
                handleRefBet={handleRefBet}
                setColumnFilters={setColumnFilters}
                columnFilters={columnFilters}
                onMouseTextRight={[
                    t('Edit'),
                    t('Archive'),
                    t('ChangeBids'),
                    'Массовое изменение стран',
                    'Массовое изменение городов',
                ]}
                onMouseEditRight={onMouseEditRight}
                onRow={onRowDouble}
                order={handleOrder}
                pagination={{
                    pageSize: page,
                    total: Number(total),
                    current: current,
                    showSizeChanger: true,
                }}
                onChangePagination={onChangePagination}
                filters={filtersColumn}
                filtersFetch={filtersFetch}
                handleDeleteCopyAll={handleArchive}
                columns={columns(t)}
                loading={loading}
                height={'calc(-231px + 100vh)'}
                dataSource={dataAllBids}
                langs={langs}/>,
        },
    ];

    return (
        <Layouts>
            <HeaderContentComponent setDataAllBids={setDataAllBids} arButton={arButton} title={t('Bids')}
                                    locale={locale}/>
            <Space direction="vertical" size="middle" style={{width: '100%'}}>
                {langs &&
                    <Tabs
                        onTabClick={handleTab}
                        defaultActiveKey={langs && langs === 'ru' ? '1' : '2'}
                        items={items}
                        style={{margin: 'auto 16px'}}
                    />
                }
            </Space>
            <DrawerComponent open={openDrawerContainer} onClose={closeFormNewBet}>
                <FormNewBet
                    closeForm={closeFormNewBet}
                    setDataAllBids={setDataAllBids}
                    dataRows={dataRows}
                    isTypeForm={isTypeForm}
                    setCity1={setCity1}
                    setCity2={setCity2}
                    dataCity1={dataCity1}
                    dataCity2={dataCity2}
                    pagination={{
                        pageSize: page,
                        total: Number(total),
                        current: current,
                        showSizeChanger: true,
                    }}
                />
            </DrawerComponent>
            <DrawerComponent
                open={openDrawerViewContainer}
                onClose={closeFormViewBet}
            >
                <FormViewBet
                    typePage={true}
                    setOpenDrawerContainer={setOpenDrawerContainer}
                    setOpenDrawerViewContainer={setOpenDrawerViewContainer}
                    setIsTypeForm={setIsTypeForm}
                    dataRows={dataRows}
                />
            </DrawerComponent>
            <ModalConfirm
                title={t('SendArchive')}
                subtitle={t('DescArchive')}
                isOpen={confirmation}
                closeModal={onCloseModalConfirm}
                actionAfterConsent={onOkModalConfirm}
            />
            <Modal open={isOpenRefBet} centered title={t('ChangeBids')}
                   width={600} footer={null} onCancel={handleCancelRefBet}>
                <Form form={form} onFinish={handleOkRefBet} layout="vertical">
                    <Flex gap={10} vertical justify={'flex-end'} align={'end'}>
                        <Flex gap={10}>
                            <Form.Item name={'bet'} label={t('Bet')}>
                                <Input
                                    value={refBetPrice}
                                    allowClear
                                    onChange={handleInputChangeRefBet}
                                    addonAfter={suffixSelector}
                                />
                            </Form.Item>
                            <Form.Item style={{width: '30%'}} name={'cnp'} label={t('Overdue')}>
                                <NumericInput
                                    value={refBetCNP}
                                    onChange={handleInputChangeCNP}
                                />
                            </Form.Item>
                            <Form.Item style={{width: '40%'}} name={'col_ktk'} label={t('CpcNumber')}>
                                <NumericInput
                                    value={refBetColKtk}
                                    onChange={handleInputChangeColKtk}
                                />
                            </Form.Item>
                        </Flex>
                        <Flex>
                            <Form.Item>
                                <Flex gap={10}>
                                    <Button onClick={handleCancelRefBet}>{t('Cancel')}</Button>
                                    <Button type={'primary'} htmlType={'submit'}>OK</Button>
                                </Flex>
                            </Form.Item>
                        </Flex>
                    </Flex>
                </Form>
            </Modal>
        </Layouts>
    );
};

export default Index;
